<template lang="pug">
  div.drug-setting-panel
    div.nav.flex-column.nav-pills.nav-fill.drug-setting-nav
      router-link.nav-link(:to="{ name: 'DrugDBSettings' }") 藥物資料庫
      router-link.nav-link(:to="{ name: 'DrugGroupSettings' }") 藥物群組
      router-link.nav-link(:to="{ name: 'ComboSettings' }" v-if="serverPrivilege.schedule") 套藥設定
      //- temporaliy remove this link, due to related userflow not implmented well yet.
      //- router-link.nav-link(:to="{ name: 'ControlDrugSettings' }" v-if="serverPrivilege.schedule") 管制藥組

    router-view

</template>

<script>
export default {
  name: 'DrugList',
  computed: {
    serverPrivilege() {
      return this.$store.state.user.user.server_privilege;
    },
  },
};
</script>

<style lang="sass">
.drug-setting-panel
  display: flex
  .drug-setting-nav
    width: 200px
  .nav-link
    border-radius: 0px
    color: gray
  .drug-panel
    padding-left: 10px
    width: calc(100%)
  .active
    background-color: steelblue !important

.drug-panel--head
  margin-bottom: 10px
  h6
    display: inline-block



</style>




// WEBPACK FOOTER //
// DrugSettings.vue?8edf7a62